import { gql } from '@apollo/client'

export const GET_ARTICLES_HOME = gql`
  query getArticlesFromHome {
    CP_Article (
      sort: ["sort", "-date_created"]
      limit: 5
    ) {
      id
      title
      image {
        id
      }
      resume
      sort
      status
      content
      date_created
      date_updated
      category {
        id
        icon
        title
      }
      help_section {
        id
        icon
        title
      }
      comments {
        id
        title
        comment
      }
    }
    CP_Help_Sections {
      id
      icon
      title
    }
  }
`
